import ResponseStatusBadge from './ResponseStatusBadge.jsx'
import StepNarration from './StepNarration.jsx'
import WorkflowStep from './WorkflowStep.jsx'
import styles from './AIResponseLog.module.scss'

/**
 * @typedef {{
 *   kind?: 'action' | 'narration',
 *   durationMs?: number,
 *   actionName?: string,
 *   content?: string,
 *   arguments?: string | Record<string, unknown>,
 *   result?: string | Record<string, unknown>,
 *   status?: 'ok' | 'needs_review' | 'error',
 *   defaultExpanded?: boolean,
 * }} WorkflowTraceStep
 */

/**
 * @param {{
 *   status?: 'ok' | 'needs_review' | 'error',
 *   steps?: WorkflowTraceStep[],
 *   showLogStatus?: boolean,
 *   streaming?: boolean,
 * }} props
 */
export default function AIResponseLog({ status, steps = [], showLogStatus = false, streaming = false }) {
  if (!steps.length) return null

  const lastIndex = steps.length - 1

  return (
    <div className={styles.log}>
      {showLogStatus && status ? (
        <div className={styles.logStatusRow}>
          <ResponseStatusBadge status={status} />
        </div>
      ) : null}
      {steps.map((step, i) => {
        if (step.kind === 'narration') {
          const isActiveNarration = streaming && i === lastIndex
          return (
            <StepNarration key={`narration-${i}`} content={step.content} streaming={isActiveNarration} />
          )
        }
        return (
          <WorkflowStep
            key={`${step.actionName ?? 'step'}-${i}`}
            step={step}
            isLast={i === steps.length - 1}
          />
        )
      })}
    </div>
  )
}
